export default __webpack_public_path__ + "static/media/3085.fcaf3e10.jpg";